<template>
<!-- 生活直播 -->
  <div class="shortVideo" v-wechat-title="this.title">
    <div class="shortVideoCon" :style="'height:'+fullHeight+'px'">
        <div  @click.stop="pauses()" v-show="show=='1'" class='stops'></div>
        <!-- :style="'height:'+fullHeight+'px'" -->
        <div v-show="ishideDiv == '1'" class="cengs"   style="width:100%;height:100%;position:absolute;top:0;left:0;z-index:20;background-position: center;background-repeat: no-repeat;">
          <div v-show="ishideDiv == '1'" style="position:absolute;left:0;top:0;width:100%;height:100%;background:rgba(0,0,0,0.2);z-index:100;">
            <img @click.stop="playVideo()" src="../../assets/liveplay.png" alt="" style="position:absolute;left:3.04rem;top:40%;width:1.42rem;height:1.42rem;z-index:1111;">
          </div>
        </div>
        <img v-show="stops=='1'" @click.stop="playVideo()" src="../../assets/liveplay.png" alt=""
          style="position:absolute;left:3.04rem;top:40%;width:1.42rem;height:1.42rem;z-index:1111;">
        <div   style="font-size:0.12rem;height:100%;" id='id_test_video'  class="id_test_vide" webkit-playsinline="" playsinline="" x5-playsinline="" x-webkit-airplay="allow"  x5-video-player-type="h5" x5-video-player-fullscreen="" x5-video-orientation="portraint">
        <!-- :style="'height:'+fullHeight+'px'" -->
        </div> 
        <div class="shortVideoInfo">
          <div class='comperebox'>
            <div class="compereImg">
              <img :src="lifeLiveinfo.avatar" alt="">
            </div>
            <div class="compereName">
              <p class="isName">{{lifeLiveinfo.nickname}}</p>
              <p class="isIn">{{lifeLiveinfo.text}}</p>
            </div>
          </div>
          <div class="star">
            <p class="starNumber"  @click="submitFn">
                打开APP
            </p>
          </div>
        </div>
        <div class="isMute" v-if="ishideDiv == '0'">
           <img @click="isMute(false)" src="../../assets/isMute.png" alt=""  v-show="canMute == '1'">
           <img @click="isMute(true)" src="../../assets/noMute.png" alt=""  v-show="canMute == '0'">
        </div>
        <div class="isMute" v-if="ishideDiv == '1'">
           <img  src="../../assets/isMute.png" alt="">
        </div>
        <div class="bottomInfo">
           <div class="isTopic">
            {{radioInfo.title}}
           </div>
           <div class="isOperation">
              <div class="left">
                  <div class="pImg"  @click="submitFn">
                      <img :src="radioInfo.author_avatar" alt="" class="img1">
                      <img  src="../../assets/isfollow.png" class="img2">
                  </div>
                  <div class="pName">
                    <p>{{radioInfo.author_nickname}}</p>
                  </div>
              </div>
              <div class="real">
                 <div  @click="submitFn">
                   <img  src="../../assets/isLove.png" >
                   <p>
                      {{radioInfo.star  | peopleNumber}}
                      <font v-if="radioInfo.star != undefined &&  radioInfo.star.length>=5">w+</font>
                   </p>
                 </div>
                  <div  @click="submitFn">
                   <img  src="../../assets/isComment.png">
                   <p>
                      {{radioInfo.comment  | peopleNumber}}
                      <font v-if="radioInfo.comment != undefined &&  radioInfo.comment.length>=5">w+</font>
                   </p>
                 </div>
                  <div  @click="submitFn">
                   <img  src="../../assets/isShare.png">
                   <p>
                      {{radioInfo.share  | peopleNumber}}
                      <font v-if="radioInfo.share != undefined && radioInfo.share.length>=5">w+</font>
                   </p>
                 </div>
              </div>
           </div>
        </div>
    </div>
     <toast></toast>
  </div>
</template>
<script>
  import  myfooter from '../commen/myfooter'
  import cbct from '../../../static/js/base.js'
  import toast from '../commen/toast.vue'
  import share from '../../../static/js/share.js';
  import qs from 'qs'
  import Swiper from 'swiper'
  let connection = navigator.connection||navigator.mozConnection||navigator.webkitConnection||{tyep:'unknown'};
  let type_text = ['unknown','ethernet','wifi','2g','3g','4g','none'];
  export default {
    name: 'shortVideo',
    props: {
    
    },
    data(){
      return {
        hls_url:'',
        lifeLiveinfo:[],
        type:'',
        number:'',
        autoplay:false,
        radioInfo:{},
        title:"听见广播",
        appName:'-听见广播',
        ishideDiv:'1',
        stops:'0',
        show:'0',
        timer:'',
        //背景图
        out_image:'',
        // 释放视频播放器
        player1:null, 
        canMute:'0',//静音状态
        fullHeight:document.documentElement.clientHeight,
        video_id:'',//视频id
      }
    },
    filters:{
      peopleNumber:function(n1){
          // console.log('n1',n1.length);
          if(n1!=undefined) {
            let strNum="";
          if (n1.length>=5) {
            strNum=(parseFloat(n1/10000).toFixed(1))
          }else{
            strNum=n1
          }
            return strNum     
          }
          
      }
    },
  created(){
    let self=this;
    if(self.$route.query.number){
      self.number=self.$route.query.number;
    }
    if(self.$route.query.video_id){
      self.video_id=self.$route.query.video_id;
    }
  },
  methods:{
      submitFn(){
        this.$router.push({
            path:'downloadApp?video_id='+this.video_id+'&isFrom=shortVideo'
        })
      },
      isMute(muted){
          if (this.stops == '1') {
            return
          }
          if (muted) {
            this.canMute='1'
          }else{
            this.canMute='0'
          }
          $('video')[0].muted=muted
      },
      isLives:function(){
        var self = this;
        self.$api.post(cbct.baseurl+"share/short-video",
          qs.stringify({
            'number':self.number,
            'video_id':self.video_id,
          })).then(function(res){
            if (res.c==cbct.code.successCode) {
              if(res.d.info.status == '1'){
                  self.$router.push({
                    path:'delPage'
                  })
              }
            self.radioInfo=res.d.video;
            self.lifeLiveinfo=res.d.info;
            self.hls_url=res.d.video.url;
            self.out_image = res.d.video.poster_url;
            share.share(self,window.location.href,self.radioInfo.title,self.radioInfo.author_nickname,self.radioInfo.author_avatar,self.radioInfo.title);
            share.QQshare(window.location.href,self.radioInfo.title,self.radioInfo.author_nickname,self.radioInfo.author_avatar)
            $('.cengs').css('background-image','url('+(res.d.video.poster_url)+')');
            $('.cengs').css('background-size','100% 100%');
           self.player1= new TcPlayer('id_test_video', {
                    "mp4": self.hls_url,
                    autoplay:false,//iOS下safari浏览器，以及大部分移动端浏览器是不开放视频自动播放这个能力的
                    "width" :  '100%',//视频的显示宽度，请尽量使用视频分辨率宽度
                    "height" : '100%',//视频的显示高度，请尽量使用视频分辨率高度
                    flashUrl:'//imgcache.qq.com/open/qcloud/video/player/release/QCPlayer.swf',
                    // poster:this.cbct.imgUrlImg()+this.cbct.getCookie('image'),
                    systemFullscreen:false,
                    // poster:self.out_image,
                    muted:true,
                    "wording": {
                        2032: "请求视频失败，请检查网络",
                        2048: "请求m3u8文件失败，可能是网络错误或者跨域问题"
                    },
                    'controls':'none',
                    h5_flv:true,
                    flash:true,
                    live:true,
                    x5_player:true,
                    x5_orientation:2,
                    listener:function(msg){
                    // $('video').css('object-fit','fill');
                       
              }
            
            })
          }else{
              self.bus.$emit('toast',{show:true,title:res.m})
          } 
        });
      },
      playVideo:function(){
        $('video')[0].play();
        this.ishideDiv = '0';
        $('video')[0].muted = false;
        this.stops='0';
        this.show='1';
        this.canMute = '0';
      },
      pauses:function(){
          $('video')[0].pause();
          $('video')[0].muted = true;
          this.stops='1';
          this.canMute = '1';
      },
    
  },
  mounted(){
   let self=this;
   if(self.$route.query.number){
     self.number=self.$route.query.number;
   }
   if(self.$route.query.video_id){
     self.video_id=self.$route.query.video_id;
   }
    self.isLives();
  },
  destroyed(){
     if(this.timer != ''){
          clearInterval(this.timer);
        }
  },
  components: {
      toast,
    }
}
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .shortVideo{
    width: 100%;
    box-sizing: border-box;
    overflow: hidden;
  } 

  .shortVideoCon{
    position: relative;
    width: 100%;
    /* height: 13.34rem; */
  }
  .id_test_vide{
    width: 100%;
    z-index: 10 !important;
    /* height: 13.34rem; */
  }
  .shortVideoInfo{
    box-sizing: border-box;
    position: absolute;
    left:0;
    height: 1.2rem;
    background:rgba(0,0,0,0.25);
    top: 0;
    z-index: 10000 !important;
    font-size: 0.3rem;
    width: 100%;
    padding: 0 0.3rem;
    display: flex;
    justify-content: space-between;
    align-items: center;
    overflow: hidden;
  }
  .isMute{
    box-sizing: border-box;
    position: absolute;
    left:0.32rem;
    z-index: 10000 !important;
    top: 1.42rem;
  }
  .isMute img{
    width: 0.56rem;
    height: 0.56rem;
  }
  .comperebox{
    display: flex;
    align-items: center;
  }
  .compereImg{
    width:0.88rem;
    height:0.88rem;
    border-radius: 100%;
    border:solid 1px rgba(255,255,255,1);
  }
  .compereImg img{
    width: 100%;
    height: 100%;
    border-radius: 100%;
  }
  .compereName{
    text-align: left;
    margin-left: 0.16rem;
    color:rgba(255,255,255,1);
  }
  .isName{
    font-size:0.32rem;
    font-weight:500;
    line-height: 0.44rem;
  }
  .isIn{
    padding-top: 0.1rem;
    max-width: 4.1rem;
    overflow: hidden;
    text-overflow:ellipsis;
    white-space: nowrap;
    font-size:0.24rem;
  }
  .star{
    width:1.48rem;
    height:0.58rem;
    line-height: 0.6rem;
    background:rgba(255,77,104,1);
    border-radius:0.08rem;
  }
  .starNumber{
    font-size:0.28rem;
    font-weight:500;
    color:rgba(255,255,255,1);
  }
  .bottomInfo{
    position: fixed;
    left:0;
    width: 100%;
    height: 4.44rem;
    background: linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.4) 100%);
    box-sizing: border-box;
    bottom: 0;
    /* bottom: 0.4rem; */
    z-index: 10000 !important;
  }
  .isTopic{
    position: absolute;
    left:0.3rem;
    bottom: 2rem;
    letter-spacing: 1px;
    color:rgba(255,255,255,1);
    line-height:0.4rem;
    text-shadow:1px 1px 1px rgba(0,0,0,0.5);
    font-size:0.28rem;
    font-weight:400;
    text-align: left;
    width: 73%;
    line-height: 0.45rem;
  }
 
  .isOperation{
    position: absolute;
    bottom: 0.4rem;
    width: 100%;
    box-sizing: border-box;
    padding: 0 0.3rem;
    display: flex;
    justify-content: space-between;
    font-size:0.28rem;
    font-weight:500;
    color:rgba(255,255,255,1);
  }
  .left{
    position: relative;
    display: flex;
    align-items: center;
    top: -0.15rem;
    /* margin-bottom: 0.7rem; */
  }
  .pName{
    margin-left: 0.2rem;
  
  }
  .pName p{
    text-align: left;
    width: 1.7rem;
    overflow: hidden;
    text-overflow:ellipsis;
    white-space: nowrap;
    font-weight: 500;
    font-size: 0.28rem;
    line-height: 0.32rem;
    text-shadow: 1px 1px 1px rgba(0, 0, 0, 0.2);
  }
  .pImg{
    position: relative;
    width: 0.96rem;
    height: 0.96rem;
    border-radius: 100%;
    border: solid 1px white;
  }
  .pImg .img1{
    width: 100%;
    height: 100%;
    border-radius: 100%;
  }
  .pImg .img2{
    position: absolute;
    width: 0.44rem;
    height: 0.44rem;
    left: 0.26rem;
    top: 0.74rem;
  }
  .real{
    display: flex;
    align-items: center;
  }
  .real p{
    font-size: 0.24rem;
    font-weight: 500;
    line-height: 0.34rem;
    margin-top: 0.06rem;
  }
  .real div{
    margin-left: 0.4rem;  
  }
  .real img{
    width:0.88rem;
    height:0.88rem;
  }
  .vcp-fullscreen-toggle{
    display: none;
  }
  div.vcp-player.touchable{
    z-index: 10 !important;
  }
  .stops{
    width: 100%;
    height: 80%;
    position: absolute;
    background-color: white\0;
    filter: alpha(opacity=0);
    opacity: 0;
    z-index: 1001;
    top: 0;
    left: 0;
  }

</style>
